import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, FormField } from '../../components'
import { useStateContext } from '../../contexts/ContextProvider';
import { signIn, getCurrentUser } from '../../lib/appwrite';

const SignIn = (props) => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [emailErorr, setEmailError] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordError, setPasswordError] = useState(false)
  const [signInError, setSignInError] = useState('')
  const [isSubmitting, setSubmitting] = useState(false);
  const { setIsLoggedIn } = useStateContext();

  const { currentColor, setAccount } = useStateContext();

  const submit = async () => {
    if (email === "" || password === "") {
      setSignInError("Error", "Please fill in all fields");
    }

    setSubmitting(true);

    try {
      await signIn(email, password);

      const result = await getCurrentUser();
      setAccount(result)
      setIsLoggedIn(true);
      navigate('/')

    } catch (error) {
      setEmailError(true)
      setPasswordError(true)
      console.error(error)
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen dark:bg-main-dark-bg">
      <div className="font-bold text-4xl mb-4 dark:text-gray-100">Wildlife Comforts</div>
      <div className='p-5 space-y-4'>
        <FormField
          title="Email"
          value={email}
          handleChangeText={(e) => setEmail(e)}
          placeholder="Enter your email"
          error={emailErorr}
        />
        <FormField
          title="Password"
          value={password}
          handleChangeText={(e) => setPassword(e)}
          placeholder="Enter your password"
          error={passwordError}
        />
        <p>{signInError}</p>
      </div>

      <a href='/signup'>
        Sign Up
      </a>

      <div
        className='pt-8'
        onClick={submit}
      >
        <Button
          bgColor="#4caf50"
          color={'white'}
          text="Log In"
          borderRadius="10px"
          size="md"
        />
      </div>
    </div>
  );
}

export default SignIn